import { render, staticRenderFns } from "./libros.vue?vue&type=template&id=1f0077e8"
import script from "./libros.vue?vue&type=script&lang=js"
export * from "./libros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports